import { render, staticRenderFns } from "./DxzlzxJdHome.vue?vue&type=template&id=3185c02a&scoped=true"
import script from "./DxzlzxJdHome.vue?vue&type=script&lang=js"
export * from "./DxzlzxJdHome.vue?vue&type=script&lang=js"
import style0 from "./DxzlzxJdHome.vue?vue&type=style&index=0&id=3185c02a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3185c02a",
  null
  
)

export default component.exports